import React from 'react';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { findOptionsForSelectFilter } from '../../util/search';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink, NamedLink } from '../../components';
import { EditListingDescriptionForm } from '../../forms';
import config from '../../config';

import css from './EditListingInstructionPanel.module.css';
import HelpAndContact from '../HelpAndContact/HelpAndContact';

import EditListingInstructionsForm from '../../forms/EditListingInstructionsForm/EditListingInstructionsForm';
import { createSlug } from '../../util/urlHelpers';

const EditListingInstructionPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    formApi,
    form,
    userNativeLang,
    history,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);

  const { publicData } = currentListing.attributes;

  const {
    jobInstruction,
    groomingRestrictions,
    languageRequirements,
    newJobInstructionArray,
  } = publicData;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingInstructionPanel.listingTitle"
      values={{
        listingTitle: (
          <ListingLink listing={listing}>
          </ListingLink>
        ),
      }}
    />
  ) : (
    <FormattedMessage id="EditListingDescriptionPanel.ListYourJob" />
  );

  const certificateOptions = findOptionsForSelectFilter('certificate', config.custom.filters);

  return (
    <div className={classes}>
      <HelpAndContact />
      <div className={css.editHeadingDiv}>
        <h1 className={css.title}>{panelTitle}</h1>
        {currentListing?.id?.uuid && isPublished && (
          <div>
            <NamedLink
              name="ListingPage"
              params={{
                id: currentListing?.id?.uuid,
                slug: createSlug(currentListing?.attributes?.title || ''),
              }}
            >
              <FormattedMessage id="EditListing.GoToListing" />
            </NamedLink>
          </div>
        )}
      </div>
      <EditListingInstructionsForm
        className={css.form}
        initialValues={{
          jobInstruction: jobInstruction,
          groomingRestrictions,
          languageRequirements,
          newJobInstructionArray,
        }}
        saveActionMsg={submitButtonText}
        onSubmit={values => {
          const {
            jobInstruction,
            groomingRestrictions,
            languageRequirements,
            newJobInstructionArray,
          } = values;

          const validLanguageRequirements = (languageRequirements || []).filter(
            req => !!(req.id && req.language && req.minimumLevel)
          );

          const updateValues = {
            publicData: {
              jobInstruction: jobInstruction,
              groomingRestrictions,
              languageRequirements: validLanguageRequirements,
              // searchLanguage: [languageRequirements[0]?.language?.value],
              searchLanguage: languageRequirements?.map(m => m?.language?.value),
              newJobInstructionArray,
            },
          };
          onSubmit(updateValues);
        }}
        onChange={onChange}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
        certificateOptions={certificateOptions}
        formApi={form}
        userNativeLang={userNativeLang}
        history={history}
        currentListing={currentListing}
      />
    </div>
  );
};

EditListingInstructionPanel.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingInstructionPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingInstructionPanel;
